<template>
    <svg class="svg-icon flex-shrink-0 flex-grow-0" xmlns="http://www.w3.org/2000/svg" :style="style">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" :xlink:href="href" />
    </svg>
</template>

<script>
export default {
    name: 'SvgIcon',

    props: {
        name: {
            type: String,
            default: undefined
        },

        size: {
            type: String,
            default: '16px'
        },

        color: {
            type: String,
            default: 'inheirt'
        }
    },

    computed: {
        href() {
            return '#' + this.name;
        },

        style() {
            const { size, color } = this;
            return {
                color,
                width: size,
                height: size
            };
        }
    }
};
</script>

<style scoped lang="scss">
.svg-icon {
    fill: currentColor;
}
</style>
